module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    class: {
      selected: _vm.isSelected,
      'edit-mode': _vm.isEditMode,
    },
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode),
      expression: "!isEditMode"
    }],
    staticClass: "tick-img",
    attrs: {
      "src": "/display/static/images/tick.svg"
    }
  }), _vm._v(" "), (_vm.oldImages) ? _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "left": "0"
    },
    attrs: {
      "src": _vm.getShot,
      "id": _vm.item.id,
      "loading": "lazy",
      "decoding": "async",
      "index": !_vm.oldImages
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.oldImages) ? _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "left": "0"
    },
    attrs: {
      "src": _vm.getShot,
      "id": _vm.item.id,
      "loading": "lazy",
      "decoding": "async",
      "index": _vm.oldImages
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "title-screen"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.item.screens) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.screens[0].title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && !_vm.item.screens) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.haveScreen) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHover),
      expression: "isHover"
    }],
    staticClass: "fa  icon-layers text-right",
    attrs: {
      "id": "fa-clone"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHover),
      expression: "isHover"
    }],
    staticClass: "text-center",
    staticStyle: {
      "transform": "translateY(50%)"
    }
  }, [(_vm.haveScreen && !_vm.isCollapse2) ? _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    attrs: {
      "id": _vm.item.id,
      "variant": "outline-primary"
    },
    on: {
      "click": [function($event) {
        return _vm.$emit('showSelect', $event)
      }, function($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('button.preview')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.haveScreen && _vm.isCollapse2) ? _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    attrs: {
      "id": _vm.item.id,
      "variant": "outline-primary"
    },
    on: {
      "click": [function($event) {
        return _vm.$emit('showSelect2')
      }, function($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('button.preview')) + "\n      ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.item.duration && !_vm.isEmpty && _vm.isActiveModule === 'videos') ? _c('div', {
    staticClass: "duration-screen"
  }, [_c('div', {
    staticClass: " duration-screen__style",
    attrs: {
      "title": _vm.item.duration
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getDuration(_vm.item.duration)) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalSegment),
      expression: "ModalSegment"
    }],
    staticClass: "edit-panel",
    attrs: {
      "id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('labels.title'),
      "placeholder": _vm.$t('placeholder.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isHover) ? _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateTitleScreen()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isHover) ? _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateSegment()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalSegment != true),
      expression: "ModalSegment != true"
    }],
    staticClass: "edit-panel",
    attrs: {
      "id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleSlide),
      expression: "titleSlide"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('labels.title'),
      "placeholder": _vm.$t('placeholder.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.titleSlide)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleSlide = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.update()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9609ab20","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/SlideCard.vue
// module id = 845
// module chunks = 1 3